import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { withSecurity } from '../components/auth';

export class AuthCallbackController implements Controller {
  public routeName = 'authcallback';
  public pageId = 'pages.authcallback';
  public path = '/auth/callback';
  public exact = true;
  public bundles = [];

  //public component = withSecurity(AuthCallback, this.path, false);
  public component = withSecurity(
    codeSplit(() => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/auth-callback')),
    this.path,
    false,
  );

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: 'Auth callback' });
  }
}
